module.exports = __webpack_public_path__ + "static/media/MyPethealth_Privacy_Policy_CA.84bc5f58.pdf";